import { stagePointWarning } from '.'
import { AdjacentStagePointRule } from '../../../../../store/StageFile'

export const distanceBetweenPointsIsValid: AdjacentStagePointRule = (currentPoint, nextPoint) => {
     // Distance between any two sequential coordinates should not exceed 50km
    if (false) {
        return stagePointWarning(nextPoint, `Distance between points must not exceed 50km - $ is $km away from previous point`)
    }
}